export default __webpack_public_path__ + "static/media/73-min.8d60414f.jpg";